/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { WorkoutListItem } from './WorkoutListItem';
import { sortBy } from 'lodash';
import { Program } from '@playbook-technologies/common-enums';
import auth from '@client/components/auth';
import _ from 'lodash';
import { programUrl as getProgramUrl } from '@client/new/helpers/landingPages';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { AnyFn } from '../../../../new/helpers/types';
import { Link } from 'react-router';
import { Button } from '@mui/material';

type ProgramSectionProps = {
  program: any;
  onReorder: any;
  influencerId: number;
  influencer: any;
  onChange?: AnyFn;
};
export class ProgramSection extends React.Component<ProgramSectionProps> {
  constructor(props) {
    super(props);
    this.onWorkoutSort = this.onWorkoutSort.bind(this);
    this.moveUpWorkout = this.moveUpWorkout.bind(this);
    this.moveDownWorkout = this.moveDownWorkout.bind(this);
  }
  onWorkoutSort(workouts) {
    const ids = workouts.map((w) => w.id);
    //console.log('reorder like this.', ids);
    this.props.onReorder(this.props.program.id, ids);
  }
  moveUpWorkout(index) {
    if (index < 1) return;
    const workouts = this.customOrderedWorkouts().slice();
    const t = workouts[index];
    workouts[index] = workouts[index - 1];
    workouts[index - 1] = t;
    this.onWorkoutSort(workouts);
  }
  moveDownWorkout(index) {
    if (index > this.customOrderedWorkouts().length - 1) return;
    const workouts = this.customOrderedWorkouts().slice();
    const t = workouts[index + 1];
    workouts[index + 1] = workouts[index];
    workouts[index] = t;
    this.onWorkoutSort(workouts);
  }
  publishedWorkouts() {
    const publishedWorkouts = this.props.program.workouts.filter(
      (w) => w.publishedAt && w.isVisible,
    );
    return publishedWorkouts;
  }
  customOrderedWorkouts() {
    const publishedWorkouts = this.publishedWorkouts();
    return sortBy(publishedWorkouts, (w) => w.programIndex);
  }
  render() {
    const isWeeklyProgram = this.props.program.contentStructure === 'dayweek';
    const groupIntoWeeks = isWeeklyProgram;
    let workoutsJSX;

    if (groupIntoWeeks) {
      const publishedWorkouts = this.publishedWorkouts();
      const usedWeeks = OrderedProgram.usedWeeks(publishedWorkouts);
      const workoutsByWeek = _.groupBy(
        publishedWorkouts,
        OrderedProgram.workoutWeek,
      );

      const handleWeekDaySelect = (updatedWorkout) => {
        const updatedWorkouts = publishedWorkouts.map((w) =>
          w.id === updatedWorkout.id ? updatedWorkout : w,
        );
        this.onWorkoutSort(OrderedProgram.workoutsOrder(updatedWorkouts));
      };

      workoutsJSX = usedWeeks.map((weekId: number | null) => {
        const workoutsInWeek = workoutsByWeek[weekId];

        return (
          <div key={weekId}>
            <div
              style={{
                marginTop: '30px',
                color: 'black',
                fontWeight: 'bold',
                fontSize: '24px',
              }}
            >
              {weekId === null
                ? 'WEEK NOT SET (Please choose week & day)'
                : `WEEK: ${weekId}`}
            </div>
            <div className="groupedWorkouts">
              {sortBy(workoutsInWeek, (w) => w.name).map((w, i) => (
                <WorkoutListItem
                  type="program"
                  workout={w}
                  collection={this.props.program}
                  key={w.id}
                  totalWorkouts={publishedWorkouts.length}
                  index={i}
                  onChange={this.props.onChange}
                  onMoveUp={this.moveUpWorkout}
                  onMoveDown={this.moveDownWorkout}
                  programColor={this.props.program.color}
                  displayWeekDaySelect={isWeeklyProgram}
                  displayOrderingButtons={false}
                  onWeekDaySelect={handleWeekDaySelect}
                  influencerId={this.props.influencerId}
                />
              ))}
            </div>
          </div>
        );
      });
    } else {
      const publishedWorkouts = this.publishedWorkouts();

      workoutsJSX = publishedWorkouts.map((w, i) => {
        return (
          <WorkoutListItem
            type={this.props.program?.id === 0 ? 'channel' : 'program'}
            collection={this.props.program}
            workout={w}
            key={w.id}
            totalWorkouts={publishedWorkouts.length}
            index={i}
            onChange={this.props.onChange}
            // displayStats={1}
            displayOrderingButtons={false}
            onMoveUp={this.moveUpWorkout}
            onMoveDown={this.moveDownWorkout}
            programColor={this.props.program.color}
            displayWeekDaySelect={isWeeklyProgram}
            isHidden={
              this.props.program.workoutLimit &&
              i >= this.props.program.workoutLimit
            }
            influencerId={this.props.influencerId}
          />
        );
      });
    }

    const noWorkouts =
      this.props.program.workouts.length === 0 ? (
        <p>
          <br />
          No workouts in program.
        </p>
      ) : (
        ''
      );

    const programName = this.props.program.isVisible
      ? this.props.program.name
      : `${this.props.program.name}* (Not live)`;

    const typeOfProgram = Program.Type.fromValue(this.props.program.type);
    const url = `/admin/${this.props.influencerId}/${
      typeOfProgram === Program.Type.Program ? 'program' : 'category'
    }/${this.props.program.id}/edit#about`;

    const isLocked =
      !(auth.isAdministrator() || auth.isModerator()) &&
      this.props.program.isLocked;

    const displayOTPEditButton = this.props.program.accessType === 'exclusive';

    const programUrl = getProgramUrl(this.props.influencer, this.props.program);
    return (
      <section className="programs">
        <h2
          style={{
            background: 'white',
            border: '1px solid #fff',
            borderColor: `#${this.props.program.color}`,
            display: 'flex',
            color: 'black',
          }}
        >
          <span style={{ flex: 1, lineHeight: '2.1rem' }}>
            {programName} {isLocked && `(Read-only)`}
          </span>
          <div>
            {this.props.program.id !== 0 && (
              <Link className="dropdown-row" to={url}>
                <Button
                  className="mr-4"
                  variant="outlined"
                  style={styles.programEditButton}
                >
                  {isLocked ? 'View' : 'Edit'}
                </Button>
              </Link>
            )}
            {displayOTPEditButton && (
              <Link
                className="dropdown-row"
                to={url.replace('#about', '#sales-page')}
              >
                <Button
                  className="mr-4"
                  variant="outlined"
                  style={styles.programEditButton}
                >
                  Edit Landing Page
                </Button>
              </Link>
            )}
            {programUrl && (
              <Link
                className="dropdown-row"
                href={programUrl}
                target="_blank"
                to=""
              >
                <Button
                  className="mr-4"
                  variant="outlined"
                  style={styles.programEditButton}
                >
                  Open Landing Page
                  <Icon className="ml-1" icon={faExternalLink} />
                </Button>
              </Link>
            )}
          </div>
        </h2>
        <div className="mt-5">
          {this.props.program.workoutLimit ? (
            <p className="">
              Displaying latest {this.props.program.workoutLimit} workouts.{' '}
              <a
                className="cursor-pointer"
                href={`/admin/${this.props.influencerId}/category/${this.props.program.id}/edit#workout-limit`}
              >
                Edit
              </a>
            </p>
          ) : null}
        </div>
        {noWorkouts}
        {this.props.program.workoutLimit > 0 ? (
          <div>
            {workoutsJSX.slice(0, this.props.program.workoutLimit)}
            {workoutsJSX.length > this.props.program.workoutLimit && (
              <div>
                <div className="mb-5">
                  <div className="text-[18px] font-bold mt-10">
                    Hidden workouts:
                  </div>
                </div>

                {workoutsJSX.slice(this.props.program.workoutLimit)}
              </div>
            )}
          </div>
        ) : (
          workoutsJSX
        )}
      </section>
    );
  }
}

const styles = {
  programEditButton: {
    float: 'right',
    fontWeight: 'bold',
    fontSize: '16px',
    border: '1px solid black',
    padding: '5px 10px',
    height: '30px',
    lineHeight: '16px',
    color: 'black',
    margin: '2px 4px 0 0',
    borderRadius: '5px',
  } as React.CSSProperties,
};

class OrderedProgram {
  // NOTE: maybe switch to separate helper module

  static workoutDay(workout) {
    const match = workout.name.match(/^W\d+\/D(\d+)/);
    return match ? parseInt(match[1]) : null;
  }

  static workoutWeek(workout: { name: string }) {
    const match = workout.name.match(/^W(\d+)/);
    return match ? parseInt(match[1]) : null;
  }

  static usedWeeks(workouts) {
    workouts.map(OrderedProgram.workoutWeek);
    let usedWeeks = workouts.map(OrderedProgram.workoutWeek);

    usedWeeks = _.sortBy(_.uniq(usedWeeks), (x) =>
      x === null ? 0 : parseInt(x + '', 10),
    );

    return usedWeeks;
  }

  static workoutByWeek(program) {
    return _.groupBy(program.workouts, OrderedProgram.workoutWeek);
  }

  static workoutsOrder(workouts) {
    const orderedWorkouts = _.sortBy(workouts, (w) => {
      const week = OrderedProgram.workoutWeek(w) || 0;
      const day = OrderedProgram.workoutDay(w) || 0;
      return week * 10 + day; // NOTE: day is in 1-7 range
    });
    return orderedWorkouts;
  }
}
